import {LitElement, html, css} from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { videoPlayerCss } from '../components/slds-system';
import "./feed-view.js";
import "./not-found.js";
import "./post-actions.js";
import store from '../src/store.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { resetStateField } from '../src/store.js';
import { fetchPost } from '../src/apiActions.js';
import { getTimePassed, getVideoOrImage } from '../src/apiCommon.js';
import { SldsBaseElement } from '../components/slds-base-element.js';

@customElement('view-post')
class ViewPost extends connect(store)(SldsBaseElement) {
  @property({type: String}) id = '';
  @property({type: Object}) item = null;
  @property({type: Array}) categories = [];
  @property({type: Object}) myCategory = {};
  @property({type: String}) lastFetchedId = '';
  @property({type: Boolean}) notFound = false;
  @property({type: Boolean}) mobileMode = false;
  @property({type: Number}) scrollTop = 0;
  constructor() {
    super();
    document.addEventListener('keydown', (function(e) {
        if(e.keyCode == 27){
          this.closeDialog();
        }
    }).bind(this));
    document.body.classList.add("modal-open");
  }

  stateChanged(state) {
    if (state.post) {
      this.item = state.post;
      if (this.item.status === 'error') {
        this.notFound = true;
      }
      this.requestUpdate();
      store.dispatch(resetStateField('post'));
    }
  } 

  // If item is null then we try to fetch this post
  updated(changedProperties) {
    if (changedProperties.has('item')) {
      if (this.item?.title) {
        document.title = this.item.title + ' | Roflcopter';
      }
      setTimeout(() => {
        const video = this.shadowRoot.querySelector('video');
        if (video) {
          video.play();
        }
      }, 100);
    }
    if (changedProperties.has('item') && (this.item === null || Object.keys(this.item).length === 0)) {
      if (this.lastFetchedId !== this.id) {
        this.fetchPost();
      }
    }
  }

  async fetchPost() {
    this.lastFetchedId = this.id;
    store.dispatch(fetchPost(this.id));
  }

  lookupCategory(categories, item) {
    for (var i = 0; i < categories.length; i++) {
      if (categories[i].id === item?.channel) {
        return categories[i];
      }
    }
    return null;
  }

  closeDialog() {
    this.dispatchEvent(new CustomEvent('dialog-closed'));
    history.pushState({}, null, '/');
    document.title = 'Roflcopter | Good Mood Website';
  }

  static styles = [
    super.styles,
    videoPlayerCss(),
    css`
      .dark .slds-modal__container {
        --sds-c-modal-color-background: #3e3e3c;
      }
    .slds-modal__container {
      padding: 2rem 0;
    }
    .dark .slds-post {
      background: #3e3e3c;
    }
    .dark .slds-feed__item-comments {
      background: #514f4d;
    }
    .dark button, .dark .slds-text-title {
      color: white;
    }
    .dark .slds-has-dividers_right>.slds-item:after {
      background-color: white;
    }
    .dark .slds-box {
      border: 1px solid #514f4d;
    }
    .ads {
      height: 100%;
      text-align: center;
    }
    .dark .ads {
      background: #3e3e3c;
    }
    .slds-modal__content {
      --slds-c-modal-content-color-background: var(--background-color);
    }
    .slds-theme_warning.pro-badge {
      padding: 0px 0.1rem;
      border-radius: 0.25rem;
      font-size: 10px;
    }
    .feed-view {
      --background-color: var(--background-color);
      --table-hover: var(--table-hover);
      --text-color: var(--text-color);
      --border-color: var(--border-color);
      --input-text-color: var(--input-text-color);
    }
    .slds-avatar {
      margin-top: -1.25rem;
    }
    @keyframes pop {
      0% {
        opacity: 0;
        transform: scale(0.9);
      }
      100% {
        opacity: 1;
        transform: scale(1);
      }
    }
    .dialog-pop {
      opacity: 0;
      transform: scale(0.9);
      animation: pop 0.5s ease-out forwards;
      /* Include vendor prefixes for cross-browser compatibility */
      -webkit-animation: pop 0.5s ease-out forwards;
      -moz-animation: pop 0.5s ease-out forwards;
        -o-animation: pop 0.5s ease-out forwards;
      }
    `
  ];

  getUsernameUrl(item) {
    if (!item.posted_by) {
      return false;
    }
    return "/user/" + item.posted_by.username;
  }

  getUsername(item) {
    if (!item.username) {
      return "";
    }
    return item.username;
  }

  preventReload(event) {
    // event.preventDefault();
    // const link = event.target.closest("a");
    // if (!link) return;
    // const url = new URL(link.href);
    // const path = url.pathname;
    // this.closeDialog();
    // history.pushState({}, null, path);
    // window.dispatchEvent(new CustomEvent('route'));
  }

  render() {
    if (this.notFound) {
      return html`
      <section role="dialog" tabindex="-1" aria-modal="true" aria-labelledby="modal-heading-01" class="slds-modal slds-fade-in-open dialog-pop slds-modal_large">
        <div class="slds-modal__container slds-p-bottom_none">
          <button @click="${this.closeDialog}" class="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse">
            <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
            </svg>
            <span class="slds-assistive-text">Cancel and close</span>
          </button>
          <div class="slds-modal__content slds-p-around_medium slds-modal__content_headless" id="modal-content-id-1">
            <not-found></not-found>
          </div>
        </div>
      </section>
      <div class="slds-backdrop slds-backdrop_open" role="presentation"></div>`;
    }
    else
    {
      return html`
      <section role="dialog" tabindex="-1" aria-modal="true" aria-labelledby="modal-heading-01" class="slds-modal slds-fade-in-open dialog-pop slds-modal_large">
        <div class="slds-modal__container slds-p-bottom_none">
          <button @click="${this.closeDialog}" class="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse">
            <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
            </svg>
            <span class="slds-assistive-text">Cancel and close</span>
          </button>
          <div class="slds-modal__content slds-p-around_medium slds-modal__content_headless" id="modal-content-id-1">
            <div class="slds-grid slds-gutters slds-wrap">
              <div class="slds-col slds-p-right_none slds-p-top_medium slds-size_1-of-1 slds-large-size_1-of-4">
                <div class="slds-m-top_medium ads slds-m-right_none slds-m-top_none slds-show_x-large ads">ADS</div>
              </div>
              <div class="slds-col slds-p-right_none slds-p-left_none feed-container slds-size_1-of-1 slds-large-size_2-of-4">
                <div class="${this.mobileMode ? 'slds-p-left_large slds-p-right_large' : ''}">
                  <div class="slds-p-bottom_x-small">
                    ${this.lookupCategory(this.categories, this.item)?.icon ? html`
                    <div class="slds-show_inline-block">
                      <img src="${this.lookupCategory(this.categories, this.item)?.icon}" alt="${this.lookupCategory(this.categories, this.item)?.title}" class="slds-avatar slds-avatar_large" />
                    </div>` : ''}
                    <div class="slds-show_inline-block">
                      <a href="/interest/${this.item?.channel}" @click="${this.preventReload}">
                        <p class="slds-text-heading_small">
                          ${this.lookupCategory(this.categories, this.item)?.title}
                        </p>
                      </a>
                      <a href="/user/${this.item?.username}" @click="${this.preventReload}">${this.item?.posted_by?.displayName}</a>
                      <span class="slds-m-left_x-small timeago">${getTimePassed(this.item?.created)}</span>
                    </div>
                    <post-save .item="${this.item}" class="slds-float_right"></post-save>
                  </div>
                  <a @click="${this.openDialog}" href="/post/${this.item?.url}" class="slds-text-title_bold"><h2 class="slds-text-heading_medium ${this.mobileMode ? 'slds-m-bottom_small' : 'slds-m-bottom_x-small'}">${this.item?.title}</h2></a>
                  ${getVideoOrImage(this.item?.files, this.item?.title, this.item?.url, this.openDialog)}
                  <post-actions .item="${this.item}"></post-actions>
                  <div class="slds-m-top_small">
                    <feed-view postUrl="${this.item?.url}"></feed-view>
                  </div>
                </div>
              </div>
              <div class="slds-col slds-p-left_none slds-p-top_medium slds-size_1-of-1 slds-large-size_1-of-4">
                <div class="slds-m-top_medium ads slds-m-right_none slds-m-top_none slds-show_x-large ads">ADS</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="slds-backdrop slds-backdrop_open" role="presentation"></div>
      `
    }
  }
}
